@let rowCount = rows$ | async;
@let entries = donorTotals$ | async;
<div
  class="power-pledge-widget"
  [style.--power-pledge-row-count]="rowCount ?? 1"
  [style.--font-scale]="fontSizeScale"
  [style.font-family]="fontFamily"
  [style.font-weight]="fontWeight"
  [style.text-align]="textAlign"
>
  @if (showEmptyState$ | async) {
    <gb-presenter-widget-placeholder>
      <h1>{{ 'PRESENTER.POWER_PLEDGE_WIDGET.PLACEHOLDER_TITLE' | translate }}</h1>
      <span>{{ 'PRESENTER.POWER_PLEDGE_WIDGET.PLACEHOLDER_SUBTITLE' | translate }}</span>
    </gb-presenter-widget-placeholder>
  } @else {
    <div class="power-pledge-list" [gbFlipList]="entries">
      @for (entry of entries; track trackEntry($index, entry)) {
        <div class="power-pledge-row" [attr.data-flip-key]="entry.uuid">
          <div
            class="rank-badge"
            [style.background-color]="getRankBadgeColor(powerPledgeWidget, $index + 1)"
            [style.color]="getContrastColor(getRankBadgeColor(powerPledgeWidget, $index + 1))"
          >
            <span class="rank-number">{{ $index + 1 }}</span>
          </div>

          <div
            class="name-cell"
            [style.background-color]="resolveColor(powerPledgeWidget.table_primary_color)"
            [style.color]="getContrastColor(powerPledgeWidget.table_primary_color)"
          >
            <span class="name-text">{{ entry.name }}</span>
          </div>

          <div
            class="amount-cell"
            [style.background-color]="resolveColor(powerPledgeWidget.table_accent_color)"
            [style.color]="getContrastColor(powerPledgeWidget.table_accent_color)"
          >
            <span class="amount-text">{{ entry.total | gbCurrency }}</span>
          </div>
        </div>
      }
    </div>
  }
</div>
